module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-43.f3d5292e.png";